export default function () {

	if ( document.querySelector( '.js-tabNav' ) ) {

		document.querySelector( '.js-tabNav' ).classList.add( 'active' );
		document.querySelector( '.js-tabBody' ).classList.add( 'active' );

		// stop hash scroll behaviour but keep the hash in url
		/**
		 *
		 * @param e
		 */
		function preventScroll( e ) {

			e.preventDefault();

		}

		const preventLinks = document.querySelectorAll( '.js-preventDefault' );
		preventLinks.forEach( function ( element ) {

			element.addEventListener( 'click', preventScroll );

		} );

		// remove active state from tabNav and tabBody
		/**
		 *
		 */
		function removeActive() {

			let navs = document.querySelectorAll( '.js-tabNav.active' );

			for ( let i = 0; i < navs.length; i++ ) {

				navs[i].classList.remove( 'active' );

			}

			let bodies = document.querySelectorAll( '.js-tabBody.active' );

			for ( let i = 0; i < bodies.length; i++ ) {

				bodies[i].classList.remove( 'active' );

			}

		}

		// remove hash from url
		/**
		 *
		 */
		function removeHash() {

			history.pushState( "", document.title, window.location.pathname
        + window.location.search );

		}

		document.addEventListener( 'click', function ( event ) {

			if ( !event.target.classList.contains( 'js-tabNav' ) ) {

				return;

			}

			const body = document.querySelector( event.target.hash );

			event.preventDefault();

			if ( body.classList.contains( 'active' ) ) {

				return;

			}

			removeActive();

			event.target.classList.toggle( 'active' );
			body.classList.toggle( 'active' );

		} );

		/*const modalArgs = {
      disableScroll: true,
      awaitOpenAnimation: true,
      awaitCloseAnimation: true,
      disableFocus: true,
      onClose: modal => removeHash(),
    };*/

		// init modal
		//MicroModal.init(modalArgs);

		// check of page is loaded
		/**
		 *
		 * @param fn
		 */
		const ready = function ( fn ) {

			// if document is already loaded, run method
			if ( document.readyState === 'complete' ) {

				return fn();

			}
			// otherwise, wait until document is loaded
			document.addEventListener( 'DOMContentLoaded', fn, false );

		};

		// open tabs when loading with hash link and scroll to them
		/**
		 *
		 */
		function loadOpen() {

			if ( window.location.hash && window.location.hash !== '#data-brokers-we-cover' ) {

				const hash = window.location.hash.substring( 1 );
				const tabNr = hash.slice( -1 );
				const tabID = `sites-plan-${  tabNr}`;
				const tabHash = `#sites-plan-${  tabNr}`;
				const tabBody = document.getElementById( tabID );
				const tabNav = document.querySelector( `[href="${  tabHash  }"]` );
				const mobileTabID = `tabDrop-${  tabNr}`;
				const mobileCollapseID = `tabDrop_collapse-${  tabNr}`;
				const mobileTab = document.getElementById( mobileTabID );
				const mobileCollapse = document.getElementById( mobileCollapseID );
				const headerOffset = 120;
				const elementPosition = tabNav.offsetTop;
				const offsetPosition = elementPosition - headerOffset;
				const elementPositionMobile = mobileTab.offsetTop;
				const offsetPositionMobile = elementPositionMobile - headerOffset;

				removeActive();
				tabNav.classList.add( 'active' );
				tabBody.classList.add( 'active' );
				mobileTab.classList.add( 'open' );
				mobileCollapse.slideDown( 300 );

				const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
				if ( viewportWidth > 768 ) {

					window.scrollTo( {
						top: offsetPosition,
						behavior: "smooth"
					} );

				} else {

					window.scrollTo( {
						top: offsetPositionMobile,
						behavior: "smooth"
					} );

				}

				//MicroModal.show(hash, modalArgs);

			}

		}

		ready( function () {

			setTimeout( loadOpen, 100 );

		} );

	}

	// mobile tabs
	//
	( function () {

		const parent = document.querySelectorAll( '.js-tabDrop' );

		parent.forEach( function ( element ) {

			const toggle = element.querySelector( '.js-tabDrop_toggle' );
			const collapse = element.querySelector( '.js-tabDrop_collapse' );

			/**
			 *
			 */
			toggle.onclick = function () {

				element.classList.toggle( 'open' );
				collapse.slideToggle( 300 );

			}

		} );

	} )();

}
